import { useTabsContext } from '@/context/TabsContext';
import { getRouteTitle, getTabDisplayTitle, getTabRouteGroupLabel } from '@/utils/routeUtils';
import { Breadcrumb } from 'antd';
import React from 'react';
import { useLocation } from 'react-router-dom';

/** Page context shown between the global header and the tab strip. */
export const PageContextBar: React.FC = () => {
  const location = useLocation();
  const { activeTab } = useTabsContext();
  const currentTitle = activeTab ? getTabDisplayTitle(activeTab) : getRouteTitle(location.pathname);
  const groupKey = location.pathname.split('/').filter(Boolean)[0] || 'dashboard';
  const groupTitle = getTabRouteGroupLabel(groupKey);
  const items = groupTitle === currentTitle
    ? [{ title: currentTitle }]
    : [{ title: groupTitle }, { title: currentTitle }];

  return (
    <div className="tabs-layout-page-context" data-testid="tabs-page-context">
      <Breadcrumb aria-label="Breadcrumb" items={items} />
    </div>
  );
};

export default PageContextBar;
